<script setup>
import { ref, onMounted } from 'vue';
import Etape0 from './components/Etape0.vue';
import { globalStore } from '@/utils/store.js';


const data_etape0 = ref({});
const paragraphId = ref(0);
const loading = ref(true);
const error = ref(null);
const parcours = ref({
  currentUrl: window.location.href,
  hideTool:0,
  etape:0,
  mobile: 0,
  forfait: 0,
  multiligne: 0,
  connexion: 0,
  typeconnexion:0,
  livebox: 0,
  multilignes: {
    multiligne1: {
      forfait: 0,
      who: 0
    },
    multiligne2: {
      forfait: 0,
      who: 0
    },
    multiligne3: {
      forfait: 0,
      who: 0
    },
    multiligne4: {
      forfait: 0,
      who: 0
    }
  }
});

const tag = ref({
  tealium_event: 'product_click',
  offre_id: [],
  offre_marque: [],
  offre_type: [],
  offre_modele: [],
  offre_qte: [],
  offre_libelle: [],
  offre_prix_ttc: []
});

globalStore.tag = tag; // partage global




onMounted(async () => {
  try {
    paragraphId.value = document.getElementById('vue-app')?.dataset.paragraph;
    console.log('Para:'+paragraphId.value);
    const res = await fetch(`/packopenv3/etape0/${paragraphId.value}`);
    if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
    data_etape0.value = await res.json();
  } catch (e) {
    error.value = e.message;
  } finally {
    loading.value = false;
  }
});

</script>

<template>
  <div v-if="loading">Chargement...</div>
  <div v-else-if="error">Erreur : {{ error }}</div>
  <div v-else>
    <Etape0 :parcours="parcours" :tag="tag" :data_etape0="data_etape0" :paragraphId="paragraphId.value"/>
  </div>
</template>


